import type { VideoDirectorProposalV1, VideoDirectorProposalBatchV1 } from '../../api'
import type { VideoDirectorConceptV1 } from './videoDirectorTypes'

const LABELS = ['A', 'B', 'C'] as const

/** Map canonical Skill proposal → existing card rendering contract. */
export function mapProposalToConcept(
  proposal: VideoDirectorProposalV1,
  index: number,
): VideoDirectorConceptV1 {
  const label = LABELS[index] ?? 'A'
  const shotSummary = (proposal.shots || [])
    .slice(0, 4)
    .map(
      (s) =>
        `Shot ${s.shot_index} (${s.duration_seconds}s) ${s.shot_type}/${s.framing}: ${s.subject_action}`,
    )
    .join('\n')

  return {
    concept_id: proposal.proposal_id,
    label,
    title: proposal.title,
    tagline: proposal.one_line_concept,
    summary: proposal.why_it_fits,
    creative_direction: proposal.creative_direction,
    story_concept: proposal.narrative_structure,
    performance_direction: proposal.subject_motion,
    action_design: proposal.subject_motion,
    camera_direction: proposal.camera_language,
    pacing: proposal.pacing,
    scene_direction: proposal.environment_motion,
    lighting_direction: proposal.visual_style,
    visual_style: proposal.visual_style,
    identity_constraints: proposal.risks_or_notes || '',
    continuity_constraints: [
      `opening: ${proposal.opening_hook}`,
      `ending: ${proposal.ending_image}`,
      `audio: ${proposal.audio_direction}`,
      `strategy: ${proposal.generation_strategy}`,
    ].join('\n'),
    platform_fit: proposal.why_it_fits,
    estimated_duration_seconds: Number(proposal.estimated_duration) || 0,
    estimated_shot_count: proposal.estimated_shot_count,
    generation_strategy: proposal.generation_strategy,
    style_tags: proposal.style_tags || [],
    shot_outline: shotSummary,
    shots: (proposal.shots || []) as VideoDirectorConceptV1['shots'],
    batch_id: undefined,
  }
}

export function mapBatchToConcepts(batch: VideoDirectorProposalBatchV1 | null | undefined): VideoDirectorConceptV1[] {
  if (!batch?.proposals?.length) return []
  return batch.proposals.map((p, i) => {
    const concept = mapProposalToConcept(p, i)
    concept.batch_id = batch.batch_id
    return concept
  })
}
